import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ScrollService {

  constructor() {
    // Angular's built-in scroll restoration handles automatic scroll-to-top
    // This service provides additional manual scroll utilities
  }

  /**
   * Scrolls to the top of the page smoothly
   */
  scrollToTop(smooth: boolean = false): void {
    if (typeof window !== 'undefined') {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: smooth ? 'smooth' : 'auto'
      });
    }
  }

  /**
   * Scrolls to a specific element by ID
   */
  scrollToElement(elementId: string, smooth: boolean = true): void {
    if (typeof window !== 'undefined') {
      const element = document.getElementById(elementId);
      if (element) {
        element.scrollIntoView({
          behavior: smooth ? 'smooth' : 'auto',
          block: 'start'
        });
      }
    }
  }

  /**
   * Scrolls to a specific position
   */
  scrollToPosition(top: number, left: number = 0, smooth: boolean = false): void {
    if (typeof window !== 'undefined') {
      window.scrollTo({
        top,
        left,
        behavior: smooth ? 'smooth' : 'auto'
      });
    }
  }

  /**
   * Gets the current scroll position
   */
  getCurrentScrollPosition(): { x: number; y: number } {
    if (typeof window !== 'undefined') {
      return {
        x: window.pageXOffset || document.documentElement.scrollLeft,
        y: window.pageYOffset || document.documentElement.scrollTop
      };
    }
    return { x: 0, y: 0 };
  }

  /**
   * Checks if the user has scrolled to the bottom of the page
   */
  isAtBottom(): boolean {
    if (typeof window !== 'undefined') {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const windowHeight = window.innerHeight;
      const documentHeight = document.documentElement.scrollHeight;
      return scrollTop + windowHeight >= documentHeight - 10; // 10px threshold
    }
    return false;
  }
}
